import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HandelToastContainerComponent } from '@handel-corp/ui-components';

import { CookieConsentService } from '@core/cookies/cookie-consent.service';
import { PasswordValidationModalComponent } from '@core/auth/password-validation-modal.component';
import { CookieBannerComponent } from './shared/cookies/cookie-banner.component';
import { CookiePreferencesModalComponent } from './shared/cookies/cookie-preferences-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.cookie-banner-visible]': 'showCookieBanner()',
  },
  imports: [
    RouterOutlet,
    CookieBannerComponent,
    CookiePreferencesModalComponent,
    HandelToastContainerComponent,
    PasswordValidationModalComponent,
  ],
  template: `
    <router-outlet />
    <handel-toast-container position="top-right" />
    <app-password-validation-modal />

    @if (showCookieBanner()) {
      <app-cookie-banner />
    }

    @if (consent.preferencesOpen()) {
      <app-cookie-preferences-modal />
    }
  `,
})
export class AppComponent {
  protected readonly consent = inject(CookieConsentService);

  protected readonly showCookieBanner = computed(
    () => !this.consent.decided() && !this.consent.preferencesOpen(),
  );
}
